// removed by extract-text-webpack-plugin
module.exports = {"nonHostroot":"NonHostContainer__nonHostroot___3cswC","nonHostheaderText":"NonHostContainer__nonHostheaderText___1bjLG","fullRulesText":"NonHostContainer__fullRulesText___1TchL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Rules/Components/NonHostContainer/NonHostContainer.scss
// module id = 975
// module chunks = 0